import React from "react"
import styled from "styled-components"
import Layout from "../Layout";
import projects, {ProjectType} from "../../consts/projects";
import Reference from "../Welcome/Reference";
import {BigCenter, Center, PageTitle} from "../shared/mix";
import CTA from "../CTA";
import SEO from "../SEO";

const Portfolio = () => {
    return (
        <Layout>
            <SEO
                title="Reference — Portfolio projektů"
                breadcrumb="Reference"
                path="/reference/"
                pageType="CollectionPage"
                description="Portfolio web developera Matěje Půhoného. Webové stránky, mobilní aplikace a systémy na míru. Mailpay, Pixeland, Steller, Laser Game HK, BurzaŠkol a další projekty."
                jsonLd={{
                    "@type": "ItemList",
                    "@id": "https://puhony.eu/reference/#projects",
                    "name": "Reference — projekty Matěje Půhoného",
                    "description": "Portfolio webových stránek, aplikací a systémů na míru",
                    "numberOfItems": projects.length,
                    "itemListOrder": "https://schema.org/ItemListOrderDescending",
                    "itemListElement": projects.map((p, i) => {
                        const external = p.urls.web && !p.urls.web.includes(".pdf")
                        return {
                            "@type": "ListItem",
                            "position": i + 1,
                            "item": {
                                "@type": p.type === ProjectType.MOBILE ? "MobileApplication" : "WebSite",
                                "name": p.name,
                                "description": p.sub,
                                "image": `https://puhony.eu${p.imageUrl}`,
                                ...(external ? {"url": p.urls.web} : {}),
                                "author": {"@id": "https://puhony.eu/#person"},
                                "contributor": {"@id": "https://puhony.eu/#person"},
                            }
                        }
                    })
                }}
            />
            <Center>
                <PageTitle>Reference</PageTitle>
                <Subtitle>
                    Výběr z projektů, na kterých jsem pracoval.
                    Od webových stránek přes mobilní aplikace až po komplexní systémy.
                </Subtitle>
            </Center>
            <BigCenter>
                <ProjectList>
                    {projects.map((project, index) => (
                        <Reference project={project} index={index} key={index}/>
                    ))}
                </ProjectList>
            </BigCenter>
            <CTA/>
        </Layout>
    )
}

export default Portfolio

const Subtitle = styled.p`
  text-align: center;
  max-width: 34em;
  margin: -1.5em auto 4.5em;
  font-size: 1.15em;
  line-height: 1.7;
  opacity: 0.55;
  font-weight: 300;
`

const ProjectCount = styled.div`
  text-align: center;
  font-size: 0.8em;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.3;
  margin-bottom: 5em;
`

const ProjectList = styled.div`
  display: flex;
  flex-direction: column;
`
